import { ButtonGroup } from '@mui/material'
import { useDispatch, useSelector } from '@tabeeb/store'
import { UniqueAIObjectCreationMode } from '../../enums'
import * as annotationActions from '../../actions'
import { getUniqueAIObjectCreationMode } from '../../selectors'
import { AIAnnotationEditorModeButton } from './AIAnnotationEditorModeButton'

export interface AIAnnotationEditorModeButtonGroupProps {
  onModeChange: () => void
}

const AIAnnotationEditorModeButtonGroup = ({ onModeChange }: AIAnnotationEditorModeButtonGroupProps) => {
  const dispatch = useDispatch()

  const uniqueAIObjectCreationMode: UniqueAIObjectCreationMode = useSelector(getUniqueAIObjectCreationMode)

  const handleChangeUniqueAIObjectCreationMode = (mode: UniqueAIObjectCreationMode) => {
    dispatch(annotationActions.setUniqueAiObjectCreationMode(mode))
    onModeChange()
  }

  return (
    <ButtonGroup fullWidth>
      <AIAnnotationEditorModeButton
        label='Create New'
        isSelected={uniqueAIObjectCreationMode === UniqueAIObjectCreationMode.CreateNew}
        onClick={() => handleChangeUniqueAIObjectCreationMode(UniqueAIObjectCreationMode.CreateNew)}
      />
      <AIAnnotationEditorModeButton
        label='Select Existing'
        isSelected={uniqueAIObjectCreationMode === UniqueAIObjectCreationMode.SelectExisting}
        onClick={() => handleChangeUniqueAIObjectCreationMode(UniqueAIObjectCreationMode.SelectExisting)}
      />
      <AIAnnotationEditorModeButton
        label='Copy'
        isSelected={uniqueAIObjectCreationMode === UniqueAIObjectCreationMode.CreateNewFromExisting}
        onClick={() => handleChangeUniqueAIObjectCreationMode(UniqueAIObjectCreationMode.CreateNewFromExisting)}
      />
    </ButtonGroup>
  )
}

export default AIAnnotationEditorModeButtonGroup
